@use '@lib/assets/styles/main.scss' as *;

.root {
  text-align: center;
  background-color: $gray10;
  min-height: 100%;
  display: grid;
  grid-template-rows: min-content auto;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  position: relative;
  padding-top: 0;
}

.rootFullHeight {
  min-height: 100vh;
}

.header {
  @include responsive($md1) {
    padding-top: 12px;
  }
  @include responsive(null, $md1) {
    padding-top: 24px;
  }
  & > div {
    justify-content: space-between;
    align-items: center;
  }
}

.logo {
  display: block;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  @include responsive($xs2, $md1) {
    width: 112px;
  }
  @include responsive(null, $xs2) {
    width: 40px;
  }
  svg {
    display: inherit;
    max-width: 100%;
    height: auto;
  }
  .logoImage {
    @include responsive($xs2) {
      display: block;
    }
    @include responsive(null, $xs2) {
      display: none;
    }
  }
  .logoImageSmall {
    @include responsive($xs2) {
      display: none;
    }
    @include responsive(null, $xs2) {
      display: block;
    }
  }
}

.wrap {
  display: flex;
  flex-direction: column;
  @include responsive($md1) {
    gap: 64px;
  }
  @include responsive(null, $md1) {
    gap: 40px;
  }
  img {
    display: block;
    margin: 0 auto;
    @include responsive(null, $md1) {
      max-width: 104px;
    }
  }
  & > * {
    display: block;
  }
}

.content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.desc {
  color: $gray500;
  @include responsive(null, $md1) {
    padding: 0 16px;
  }
}

.btn {
  @include responsive(null, $md1) {
    width: 100%;
  }
}

.animationContainer {
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  @include responsive($md1) {
    width: 210px;
    height: 210px;
  }
  @include responsive(null, $md1) {
    width: 104px;
    height: 104px;
  }

  .circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: $blue500;
    border-radius: 50%;
    animation: circle1 120s ease-in-out infinite;
    @include responsive($md1) {
      width: 120px;
      height: 120px;
    }
    @include responsive(null, $md1) {
      width: 60px;
      height: 60px;
    }
  }

  .rectangle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    margin-left: 50%;
    background: rgba($gray600, 0.2);
    backdrop-filter: blur(10px);
    transform-origin: top left;
  }
}

@keyframes circle1 {
  0%, 50%, 100% {
    transform: translate(-50%, -50%) scale(1);
  }
  99.6% {
    transform: translate(-50%, -50%) scale(0.5);
  }
  99.8% {
    transform: translate(-50%, -50%) scale(1.3);
  }
  99.9% {
    transform: translate(-50%, -50%) scale(0.75);
  }
}
